import type { InvoiceItemPresetResponse, InvoiceTaxCategory } from '@/shared/api';

export interface PresetFormState {
  label: string;
  unitPrice: string;
  taxCategory: InvoiceTaxCategory;
  isActive: boolean;
  notes: string;
}

export function initialPresetState(preset: InvoiceItemPresetResponse | null): PresetFormState {
  return {
    label: preset?.label ?? '',
    unitPrice: preset ? String(preset.unitPrice) : '',
    taxCategory: preset?.taxCategory ?? 'Services',
    isActive: preset?.isActive ?? true,
    notes: preset?.notes ?? '',
  };
}
